import type { ExperimentConfig } from '../@types'

const config: ExperimentConfig[] = [
	{
		male: {
			// ?safe&utm_source=FB&country=US&area=male&exp=web_male_fasting_risk_free_offer~1
			funnel: {
				id: 'ob-male-fasting-risk-free-offer',
				locale: ['en'],
			},
			landing: {
				experiment: () =>
					import(
						/* webpackChunkName: "landing" */ '@/modules/Landing/instances/experiments/web_male_fasting_risk_free_offer'
					),
			},
			paywall: {
				experiment: () =>
					import(
						/* webpackChunkName: "plan" */ '@/modules/Paywall/instances/experiments/web_male_fasting_risk_free_offer'
					),
			},
		},
	},
]

export default config
